import { Link } from 'react-router-dom';

const anchorLinks = {
  company: [
    { label: '店舗情報', href: '#locations' },
    { label: '会社概要', href: '#company' },
    { label: '許認可情報', href: '#legal' },
  ],
  support: [
    { label: 'お問い合わせ', href: '#contact' },
    { label: 'よくある質問', href: '#faq' },
  ],
};

export default function Footer() {
  const handleClick = (href: string) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer className="bg-primary-pale border-t border-primary/10">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
          {/* Brand */}
          <div className="lg:col-span-1">
            <img
              src="https://storage.readdy-site.link/project_files/2ee58abe-fae6-4328-a0eb-d14c48309594/861b13c5-69c8-4434-a2db-fc523b4fa949_jpg_3.jpg?v=f85ac59d211f16d2022997434bc43b1c"
              alt="株式会社BotaN"
              className="h-12 w-auto object-contain mb-4"
            />
            <p className="text-sm text-gray-600 leading-relaxed mb-4">
              福岡を拠点に、買取専門店と<br />カードショップを展開しています。
            </p>
            <div className="flex flex-col gap-2 text-xs text-gray-500">
              <div className="flex items-start gap-2">
                <div className="w-4 h-4 flex items-center justify-center mt-0.5 flex-shrink-0">
                  <i className="ri-map-pin-line text-primary"></i>
                </div>
                <span>〒810-0075 福岡県福岡市中央区港1-2-18-1712</span>
              </div>
              <div className="flex items-center gap-2">
                <div className="w-4 h-4 flex items-center justify-center flex-shrink-0">
                  <i className="ri-phone-line text-primary"></i>
                </div>
                <a href="tel:092-577-9739" className="hover:text-primary cursor-pointer">092-577-9739</a>
              </div>
              <div className="flex items-center gap-2">
                <div className="w-4 h-4 flex items-center justify-center flex-shrink-0">
                  <i className="ri-mail-line text-primary"></i>
                </div>
                <a href="mailto:info@botan-buy.com" className="hover:text-primary cursor-pointer">info@botan-buy.com</a>
              </div>
              <div className="flex items-center gap-2">
                <div className="w-4 h-4 flex items-center justify-center flex-shrink-0">
                  <i className="ri-line-fill text-[#06C755]"></i>
                </div>
                <a
                  href="https://lin.ee/OGQq9z6"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:text-[#06C755] cursor-pointer transition-colors"
                >
                  天神屋 公式LINE
                </a>
              </div>
            </div>
          </div>

          {/* Business - 専用ページへの直リンク */}
          <div>
            <h4 className="text-xs font-semibold tracking-widest text-primary uppercase mb-5">BUSINESS</h4>
            <ul className="flex flex-col gap-3">
              <li>
                <Link
                  to="/tenjin-ya"
                  className="text-sm text-gray-600 hover:text-primary transition-colors cursor-pointer whitespace-nowrap flex items-center gap-1.5 group"
                >
                  <div className="w-4 h-4 flex items-center justify-center flex-shrink-0">
                    <i className="ri-store-2-line text-primary text-xs"></i>
                  </div>
                  買取専門店 天神屋
                  <div className="w-3 h-3 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity">
                    <i className="ri-arrow-right-line text-xs text-primary"></i>
                  </div>
                </Link>
              </li>
              <li>
                <Link
                  to="/mangaku"
                  className="text-sm text-gray-600 hover:text-primary transition-colors cursor-pointer whitespace-nowrap flex items-center gap-1.5 group"
                >
                  <div className="w-4 h-4 flex items-center justify-center flex-shrink-0">
                    <i className="ri-gamepad-line text-primary text-xs"></i>
                  </div>
                  カードショップ まんがく
                  <div className="w-3 h-3 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity">
                    <i className="ri-arrow-right-line text-xs text-primary"></i>
                  </div>
                </Link>
              </li>
              <li>
                <button
                  onClick={() => handleClick('#services')}
                  className="text-sm text-gray-600 hover:text-primary transition-colors cursor-pointer whitespace-nowrap flex items-center gap-1.5"
                >
                  <div className="w-4 h-4 flex items-center justify-center flex-shrink-0">
                    <i className="ri-list-check text-primary text-xs"></i>
                  </div>
                  取扱ジャンル
                </button>
              </li>
            </ul>
          </div>

          {/* Company */}
          <div>
            <h4 className="text-xs font-semibold tracking-widest text-primary uppercase mb-5">COMPANY</h4>
            <ul className="flex flex-col gap-3">
              {anchorLinks.company.map((link) => (
                <li key={link.label}>
                  <button
                    onClick={() => handleClick(link.href)}
                    className="text-sm text-gray-600 hover:text-primary transition-colors cursor-pointer whitespace-nowrap"
                  >
                    {link.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Support */}
          <div>
            <h4 className="text-xs font-semibold tracking-widest text-primary uppercase mb-5">SUPPORT</h4>
            <ul className="flex flex-col gap-3">
              {anchorLinks.support.map((link) => (
                <li key={link.label}>
                  <button
                    onClick={() => handleClick(link.href)}
                    className="text-sm text-gray-600 hover:text-primary transition-colors cursor-pointer whitespace-nowrap"
                  >
                    {link.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-primary/10 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-gray-400">© 2025 株式会社BotaN. All rights reserved.</p>
          <p className="text-xs text-gray-400 text-center">古物商許可 福岡県公安委員会 901012610013</p>
        </div>
      </div>
    </footer>
  );
}
